import { useEffect } from 'react';

interface ArticleSEOProps {
  title: string;
  description: string;
  author: string;
  thumbnailUrl: string;
  categoryName: string;
  categorySlug: string;
  articleId: number;
}

export default function ArticleSEO({
  title,
  description,
  author,
  thumbnailUrl,
  categoryName,
  categorySlug,
  articleId,
}: ArticleSEOProps) {
  useEffect(() => {
    const articleUrl = `https://www.mitaovideo.com/article/${articleId}`;
    const jsonLd = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Article',
          headline: title,
          description: description,
          author: {
            '@type': 'Person',
            name: author,
          },
          image: thumbnailUrl,
          datePublished: '2024-01-15T08:00:00+08:00',
          dateModified: '2024-06-20T10:30:00+08:00',
          publisher: {
            '@type': 'Organization',
            name: '蜜桃视频',
            url: 'https://www.mitaovideo.com',
          },
          mainEntityOfPage: {
            '@type': 'WebPage',
            '@id': articleUrl,
          },
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: 'https://www.mitaovideo.com',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: categoryName,
              item: `https://www.mitaovideo.com/category/${categorySlug}`,
            },
            {
              '@type': 'ListItem',
              position: 3,
              name: title,
            },
          ],
        },
      ],
    };

    const scriptEl = document.createElement('script');
    scriptEl.type = 'application/ld+json';
    scriptEl.setAttribute('data-schema', `article-${articleId}`);
    scriptEl.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(scriptEl);

    const prevTitle = document.title;
    document.title = `${title} - 蜜桃视频`;

    const metaDescription = document.querySelector('meta[name="description"]');
    const prevDesc = metaDescription?.getAttribute('content') || '';
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    return () => {
      if (scriptEl.parentNode) {
        scriptEl.parentNode.removeChild(scriptEl);
      }
      document.title = prevTitle;
      if (metaDescription) metaDescription.setAttribute('content', prevDesc);
    };
  }, [title, description, author, thumbnailUrl, categoryName, categorySlug, articleId]);

  return null;
}